import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";
import MultiUnitsTable from "./MultiUnitsTable";
import LocationStockTable from "./LocationStockTable";
import axios from "axios";


const InventoryStructureDetails = ({
  formData,
  setFormData,
  multiUnitsEntries,
  setMultiUnitsEntries,
  locationStockEntries,
  setLocationStockEntries,
  isEdit
}) => {
  const COMPANY_CODE = localStorage.getItem("companyCode");
  const [unitsList, setUnitsList] = useState([]);

  useEffect(() => {
    fetchUnits();
  
  }, []);

  const fetchUnits = async () => {
    try {
      const apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
      const companyCode = localStorage.getItem("companyCode");

      
      const url = `${apiPaths[0]?.API_CONFIG}/api/MasterCount/${COMPANY_CODE}/UNIT/-/-`;

      const response = await axios.get(url);
      console.log("response.data :", response.data);
      setUnitsList(response.data || []);
    } catch (err) {
      console.error("Error fetching units:", err);
    }
  };



  const updateEntries = (newEntries) => {
    setFormData((prev) => ({ ...prev, multiUnitsEntries: newEntries }));
  };
  
  const onlocationStockEntriesChange = (newEntries) =>{
    console.log("onlocationStockEntriesChange newEntries:",newEntries)
    setFormData((prev) => ({ ...prev, locationStockEntries: newEntries }));
  }
  return (
    <div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <h2 className="text-lg font-semibold text-gray-800  pt-8 ">
            Multi Units
          </h2>
          <MultiUnitsTable
            // multiUnitsEntries={formData.multiUnitsEntries ?? []}
            multiUnitsEntries={multiUnitsEntries}
            setMultiUnitsEntries={setMultiUnitsEntries}
            onEntriesChange={updateEntries}
            unitsListFromAPI={unitsList}
           formData={formData}
           isEdit={isEdit}
          />
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-800  pt-8 ">
            Location Stock
          </h2>
          <LocationStockTable formData={formData} isEdit={isEdit} onlocationStockEntriesChange={onlocationStockEntriesChange} locationStockEntries={locationStockEntries} setLocationStockEntries={setLocationStockEntries} />
        </div>
      </div>
    </div>
  );
};

export default InventoryStructureDetails;
